module.exports = __webpack_public_path__ + "img/4.ac083c4c.jpg";